import { PageTitle } from "../../components/company/ui";
import ReviewsPanel from "../../components/reviews/ReviewsPanel";
import { useT } from "../../i18n";

/** Reviews drivers left about the company, and the company's reviews of drivers. */
export default function CompanyReviews() {
  const t = useT();
  return (
    <>
      <PageTitle>{t.reviews.title}</PageTitle>
      <ReviewsPanel role="company" />
    </>
  );
}
